export { type UserSentence, userSentenceTable } from "#user-sentence-table";
